<template>
  <div class="sidebar-wrapper">
    <nav
      :class="{ sidebar: true, sidebarStatic, sidebarOpened }"
      @mouseenter="sidebarMouseEnter"
      @mouseleave="sidebarMouseLeave"
    >
      <header class="logo">
        <router-link to="/app/dashboard" class="logo-container">
          <span class="primary-word">
            <img
              v-if="sidebarOpened || sidebarStatic"
              src="@/assets/logo_new_v3.png"
              class="img-logo-full"
              alt="e-SEA"
            />
            <img v-else src="./logo_tanpa_tulisan.png" class="img-logo-icon" alt="e-SEA" />
          </span>
        </router-link>
      </header>

      <ul class="nav">
        <!-- Section Header -->
        <h5 v-if="hasRole(user, 'Superuser')" class="navTitle first">APP</h5>
        <h5 v-else class="navTitle first">Pengendalian</h5>

        <!-- Dashboard -->
        <NavLink
          v-if="hasRole(user, ['Superuser', 'Verifikator', 'Penilai', 'Pejabat'])"
          :activeItem="activeItem"
          header="Dashboard"
          link="/app/dashboard"
          iconName="flaticon-home"
          index="main"
          icon-img="sidebar/Outline/Home.svg"
          isHeader
          class="navlink"
        />

        <!-- Penilaian Laporan Tahunan -->
        <NavLink
          v-if="hasRole(user, ['Superuser', 'Verifikator', 'Penilai', 'TimPengawas', 'Pejabat'])"
          :activeItem="activeItem"
          header="Penilaian Laporan Tahunan"
          link="/app/penilaian-laporan-tahunan"
          iconName="flaticon-search"
          index="main"
          icon-img="sidebar/Fill/Search.svg"
          isHeader
          class="custom-navlink"
        />

        <!-- Rekomendasi Penilaian Pelaksanaan -->
        <NavLink
          v-if="hasRole(user, ['Superuser', 'Verifikator'])"
          :activeItem="activeItem"
          header="Rekomendasi Penilaian Pelaksanaan"
          link="/app/rekomendasi-penilaian-pelaksanaan"
          iconName="flaticon-file"
          index="rekomendasi-penilaian-pelaksanaan"
          icon-img="sidebar/Outline/Document.svg"
          isHeader
          class="custom-navlink"
        />

        <!-- Rencana Aksi -->
        <NavLink
          v-if="hasRole(user, ['Superuser', 'Verifikator'])"
          :activeItem="activeItem"
          header="Rencana Aksi"
          link="/app/rencana-aksi"
          iconName="flaticon-file"
          index="rencana-aksi"
          icon-img="sidebar/Outline/Document.svg"
          class="custom-navlink"
          :childrenLinks="[
            { header: 'Pusat', link: '/app/rencana-aksi/pusat' },
            { header: 'UPT', link: '/app/rencana-aksi/upt' },
          ]"
        />
        <NavLink
          v-else-if="hasRole(user, 'Penilai') && getUserUptScope(user) === 'pusat'"
          :activeItem="activeItem"
          header="Rencana Aksi"
          link="/app/rencana-aksi"
          iconName="flaticon-file"
          index="rencana-aksi"
          icon-img="sidebar/Outline/Document.svg"
          isHeader
          class="custom-navlink"
        />
        <NavLink
          v-else-if="hasRole(user, 'Verifikator')"
          :activeItem="activeItem"
          header="Rencana Aksi"
          link="/app/rencana-aksi"
          iconName="flaticon-file"
          index="rencana-aksi"
          icon-img="sidebar/Outline/Document.svg"
          isHeader
          class="custom-navlink"
        />

        <!-- Penilaian Pelaksanaan -->
        <NavLink
          v-if="hasRole(user, 'Superuser')"
          :activeItem="activeItem"
          header="Penilaian Pelaksanaan"
          link="/app/penilaian-pelaksanaan"
          iconName="flaticon-file"
          index="penilaian-pelaksanaan"
          icon-img="sidebar/Outline/Document.svg"
          class="custom-navlink"
          :childrenLinks="[
            { header: 'Pusat', link: '/app/penilaian-pelaksanaan/pusat' },
            { header: 'UPT', link: '/app/penilaian-pelaksanaan/upt' },
          ]"
        />
        <NavLink
          v-else-if="hasRole(user, 'Penilai')"
          :activeItem="activeItem"
          header="Penilaian Pelaksanaan"
          link="/app/penilaian-pelaksanaan"
          iconName="flaticon-file"
          index="penilaian-pelaksanaan"
          icon-img="sidebar/Outline/Document.svg"
          isHeader
          class="custom-navlink"
        />

        <!-- Pemutakhiran (Superuser) -->
        <template v-if="hasRole(user, 'Superuser')">
          <h5 class="navTitle first">Pemutakhiran</h5>
          <NavLink
            :activeItem="activeItem"
            header="Early Warning"
            link="/app/early-warning"
            iconName="flaticon-file"
            icon-img="sidebar/Outline/Document.svg"
            index="early-warning"
            :childrenLinks="[
              { header: 'Berusaha', link: '/app/early-warning/berusaha' },
              { header: 'Pemerintah', link: '/app/early-warning/pemerintah' },
              { header: 'Swasta', link: '/app/early-warning/swasta' },
            ]"
          />
          <NavLink
            :activeItem="activeItem"
            header="Habis Masa Berlaku"
            link="/app/habis-masa-berlaku"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="habis-masa-berlaku"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Perubahan"
            link="/app/perubahan"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="perubahan"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Pembatalan"
            link="/app/pembatalan"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="pembatalan"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Pencabutan"
            link="/app/pencabutan"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="pencabutan"
            isHeader
          />
        </template>

        <!-- Perizinan (Superuser & Pejabat) -->
        <template v-if="hasRole(user, ['Superuser', 'Pejabat'])">
          <h5 class="navTitle first">Perizinan</h5>
          <NavLink
            :activeItem="activeItem"
            header="Berusaha"
            link="/app/perizinan"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="chat"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Non Berusaha"
            link="/app/nonberusaha"
            iconName="flaticon-file"
            icon-img="sidebar/Outline/Document.svg"
            index="nonberusaha"
            :childrenLinks="[
              { header: 'Pemerintah', link: '/app/nonberusaha/pemerintah' },
              { header: 'Swasta', link: '/app/nonberusaha/swasta' },
            ]"
          />
        </template>

        <!-- Lainnya (Superuser) -->
        <template v-if="hasRole(user, 'Superuser')">
          <h5 class="navTitle first">Lainnya</h5>
          <NavLink
            :activeItem="activeItem"
            header="User"
            link="/app/master/user"
            iconName="fa fa-users"
            icon-img="sidebar/Outline/User.svg"
            index="User"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Jabatan"
            link="/app/master/jabatan"
            iconName="Stack"
            icon-img="sidebar/Outline/Stack.svg"
            index="Jabatan"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Web Profile"
            link="/app/web"
            iconName="Stack "
            icon-img="sidebar/Outline/Stack.svg"
            index="web"
            isHeader
            :childrenLinks="[
              { header: 'Profile', link: '/app/web/profile' },
              { header: 'Tentang', link: '/app/web/about' },
              { header: 'Pengumuman', link: '/app/web/announcement' },
              { header: 'Siaran Pers', link: '/app/web/press-release' },
              { header: 'Pelaporan', link: '/app/web/report' },
              { header: 'FAQ', link: '/app/web/faq' },
            ]"
          />
        </template>

        <!-- Pemrakarsa && selain di atas -->
        <template v-if="!hasRole(user, ['Superuser', 'Verifikator', 'Penilai', 'TimPengawas', 'Pejabat'])">
          <NavLink
            :activeItem="activeItem"
            header="Dashboard"
            link="/app/dashboard"
            iconName="flaticon-home"
            index="main"
            icon-img="sidebar/Outline/Home.svg"
            isHeader
            class="navlink"
          />
          <NavLink
            :activeItem="activeItem"
            header="Laporan Tahunan"
            link="/app/laporan-tahunan"
            iconName="flaticon-search"
            index="main"
            icon-img="sidebar/Fill/Search.svg"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Penilaian Pelaksanaan"
            link="/app/penilaian-pelaksanaan/pelaku-usaha"
            iconName="flaticon-file"
            index="penilaian-pelaksanaan-pelaku-usaha"
            icon-img="sidebar/Outline/Document.svg"
            isHeader
            class="custom-navlink"
          />
          <h5 class="navTitle first">Perizinan</h5>
          <NavLink
            :activeItem="activeItem"
            header="Berusaha"
            link="/app/perizinan"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="chat"
            isHeader
          />
          <NavLink
            v-if="user.tipe_pemohon === 'pemerintah'"
            :activeItem="activeItem"
            header="Non Berusaha"
            link="/app/nonberusaha"
            iconName="flaticon-file"
            icon-img="sidebar/Outline/Document.svg"
            index="nonberusaha"
            :childrenLinks="[
              { header: 'Pemerintah', link: '/app/nonberusaha/pemerintah' },
              { header: 'Swasta', link: '/app/nonberusaha/swasta' },
            ]"
          />
          <NavLink
            v-else
            :activeItem="activeItem"
            header="Non Berusaha"
            link="/app/nonberusaha/swasta"
            iconName="flaticon-documentation"
            icon-img="sidebar/Outline/Document.svg"
            index="chat"
            isHeader
          />
          <h5 class="navTitle first">Lainnya</h5>
          <NavLink
            :activeItem="activeItem"
            header="Profil"
            link="/app/profil"
            iconName="flaticon-person"
            index="main"
            icon-img="sidebar/Outline/User.svg"
            isHeader
          />
          <NavLink
            :activeItem="activeItem"
            header="Panduan"
            link="/app/panduan"
            iconName="flaticon-person"
            index="main"
            icon-img="sidebar/Outline/Stack.svg"
            isHeader
          />
        </template>
      </ul>
    </nav>
  </div>
</template>

<style>
.custom-navlink a {
  line-height: 18px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import isScreen from '@/core/screenHelper'
import NavLink from './NavLink/NavLink'
import Swal from 'sweetalert2'
import toast from '../../helper/toast'
import { hasRole, isVerifikatorPusat, getUserUptScope } from '../../helper/helpernew'
import axios from 'axios'

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {},
      alerts: [
        {
          id: 0,
          title: 'Sales Report',
          value: 15,
          footer: 'Calculating x-axis bias... 65%',
          color: 'danger',
        },
        {
          id: 1,
          title: 'Personal Responsibility',
          value: 20,
          footer: 'Provide required notes',
          color: 'primary',
        },
      ],
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    hasRole,
    isVerifikatorPusat,
    getUserUptScope,
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.changeSidebarActive(paths.join('/'))
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false)
        this.setActiveByRoute()
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }
    },
    async checkPemohon() {
      setTimeout(async () => {
        if (!this.user.tipe_pemohon && this.user.role == 'Pemrakarsa') {
          // kasih delay 1.5 detik

          const { isConfirmed, isDenied, isDismissed } = await Swal.fire({
            title: '🚀 Perbaharuan Sistem Baru E-SEA!',
            html: `
                  <div style="text-align: left;">
                    <p>Kami telah memperbarui <b>Sistem E-SEA</b> ke versi terbaru. Kami perlu konfirmasi kategori pengguna Anda.</p>
                  </div>
                `,
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Logout',
            cancelButtonColor: '#d01345',
            confirmButtonText: 'Pemerintah',
            denyButtonText: 'Swasta',
            showDenyButton: true,
            denyButtonColor: '#25b264',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })

          if (isConfirmed) {
            this.updateUser('pemerintah')
          } else if (isDenied) {
            this.updateUser('swasta')
          } else if (isDismissed) {
            localStorage.clear()
            // misalnya redirect ke halaman login
            this.$router.push('/login')
          }
          // 1.5 detik
        }
      }, 1500)
    },

    updateUser(jenis) {
      this.$loading(true)
      axios
        .post(
          this.baseapiPengendalian + 'api/user/' + this.user.id,
          {
            tipe_pemohon: jenis,
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        .then((respon) => {
          this.user.tipe_pemohon = jenis
          localStorage.setItem('userPengendalian', JSON.stringify(this.user))
        })
        .catch((e) => {
          toast.error(this, 'Terjadi kesalahan')
        })
        .finally(() => {
          this.$loading(false)
        })
    },
  },
  created() {
    this.setActiveByRoute()
    if (this.$route.path === '/app/dashboard') {
      if (this.user.role === 'tim_penilai_pusat' || this.user.role === 'tim_penilai_upt') {
        this.$router.push('/app/penilaian-laporan-tahunan')
      }
    }
    this.checkPemohon()
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: (state) => state.sidebarStatic,
      sidebarOpened: (state) => !state.sidebarClose,
      activeItem: (state) => state.sidebarActiveElement,
    }),
  },
}
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped />
